<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'AppDateTime',
  props: { value: String, isDate: Boolean },
  computed: {
    text() {
      const { formatDate, formatTime } = this.$options.filters
      if (this.isDate) return formatDate(this.value)
      return formatTime(this.value)
    },
  },
}
</script>
